var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagramBookMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93115 4.59729V14.5738L10.0475 11.769C10.7398 11.146 11.7907 11.146 12.483 11.769L15.5993 14.5738V4.59729H6.93115ZM17.333 3.29706C17.333 3.05769 17.1389 2.86365 16.8996 2.86365H5.63092C5.39155 2.86365 5.19751 3.05769 5.19751 3.29706V17.8825C5.19751 18.1077 5.46417 18.2264 5.63152 18.0758L11.2073 13.0576C11.2402 13.028 11.2903 13.028 11.3232 13.0576L16.899 18.0758C17.0663 18.2264 17.333 18.1077 17.333 17.8825V3.29706Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramBookMark);
export default __webpack_public_path__ + "static/media/instagramBookMark.82afcc9a.svg";
export { ForwardRef as ReactComponent };